import React, { Fragment } from "react";
import RadioButtons from "../../RadioButtons";

const options = [
  { label: "Show All", value: "all" },
  { label: "With Scheduled Tests", value: "with_scheduled_tests" },
  { label: "With Unscheduled Tests", value: "with_unscheduled_tests" }
];

export default function ScheduleStatus({ onChange, value }) {
  return (
    <Fragment>
      <label>{I18n.t("scheduled_status")}</label>
      <br />
      <RadioButtons
        name="scheduled_status"
        onChange={dropDownItem => onChange(dropDownItem.value)}
        options={options}
        value={value}
      />
    </Fragment>
  );
}
